import { PatientAdminServiceIdentity, SearchResult } from '../../types/api';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT, DISPLAY_PLACEHOLDER, getDaysAgo } from '../../utils/AccountDetailsUtil';
import { MfaState } from '../../types/mfaState';

/**
 * Converts the list of search responses (PatientAdminServiceIdentity) into the UX Model (SearchResult).
 *
 * Each result represents in one patient record in one ehrSystem. patient-ehrSystem
 */
export const mapSearchResults = (searchResponse: PatientAdminServiceIdentity[], inputSearchType: string): SearchResult[] => {
    const searchResults: SearchResult[] = [];
    searchResponse.map((res) => {
        const mfaEnabledDate =
            res.mfaConfig?.isEnabled && dayjs(res.mfaConfig?.promptedDate).isValid()
                ? new Date(res.mfaConfig?.promptedDate).toLocaleString('en-US', DATE_TIME_FORMAT)
                : DISPLAY_PLACEHOLDER;

        let mfaState: MfaState;
        if (res.mfaConfig?.isEnabled) {
            mfaState = MfaState.Enabled;
        } else if (res.mfaConfig?.isDelayed) {
            mfaState = MfaState.Delayed;
        } else if (res.mfaConfig?.isOptedOut) {
            mfaState = MfaState.Disabled;
        } else {
            mfaState = MfaState.NotConfigured;
        }

        const searchResult: SearchResult = {
            healthSystemId: res.healthSystemId,
            ehrDemographics: res.ehrDemographics,
            inputSearchType: inputSearchType,
            azureId: res.azureId,
            system: res.system,
            mrn: res.isNonPatient ? 'NON-PATIENT PROXY' : res.mrn,
            epi: res.epi,
            isStale: res.isStale,
            userLastSignedInDate:
                res.userLastSignedInDate && dayjs(res.userLastSignedInDate).isValid()
                    ? new Date(Date.parse(res.userLastSignedInDate)).toLocaleString('en-US', DATE_TIME_FORMAT)
                    : DISPLAY_PLACEHOLDER,
            mychartUserName: res.mychartUsername,
            ssoAccountUsername: res.ssoAccountUsername,
            isEmailVerified: res.isEmailVerified,
            migratedInactive: res.migratedInactive,
            requireCreateAccount: res.requireCreateAccount,
            requireMigrateAccount: res.requireMigrateAccount,
            accountAuthorizations: res.accountAuthorizations,
            accountCreationDate:
                res.userAccountCreationDate && dayjs(res.userAccountCreationDate).isValid()
                    ? new Date(Date.parse(res.userAccountCreationDate)).toLocaleString('en-US', DATE_TIME_FORMAT)
                    : DISPLAY_PLACEHOLDER,
            mfaVerificationMethod: res.mfaConfig?.preferredMfa ? res.mfaConfig?.preferredMfa : DISPLAY_PLACEHOLDER,
            mfaEnabledDate: mfaEnabledDate,
            daysSinceMFAEnabled: dayjs(mfaEnabledDate).isValid() ? getDaysAgo(mfaEnabledDate).toString() + ' days ago' : DISPLAY_PLACEHOLDER,
            mfaState: mfaState,
        };

        searchResults.push(searchResult);
    });
    return searchResults;
};
